import { ISingleIdParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IIsWorkbookServerRefreshableResult extends IResult {
  refreshable: boolean;
}

export class IIsWorkbookServerRefreshableRequest extends Request<ISingleIdParams, IIsWorkbookServerRefreshableResult> {
  constructor(params: ISingleIdParams) {
    super('isWorkbookServerRefreshable', params);
  }
}
